// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_bBD","cls2":"MultiPaperNewsStory-cls2_n_N MultiPaperNewsStory-cls1_bBD"};